import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'configuraciones/bancos/';

/**
 * GET Bancos
 * @returns {Promise<object[]>}
 */
export const getBancos = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Banco
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getBanco = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Banco
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postBanco = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Banco
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchBanco = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Banco
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteBanco = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
